<template>
  <div class="fillcontain">
    <search-item @showDialog="showClasstypeAndTimeDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="classtypeId"
          label="班级类型"
          align="left"
          :filters="this.courseTypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.classTypeId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          label="课程时长(分钟)"
          align="center"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditCoursePackage(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoursePackage(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addClasstypeAndTimeDialog.show"
        :isShow="addClasstypeAndTimeDialog.show"
        :dialogRow="addClasstypeAndTimeDialog.dialogRow"
        :courseTypeList="addClasstypeAndTimeDialog.courseTypeList"
        @getClasstypeAndTime="getClasstypeAndTime"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getFormatClassTypes } from "@/api/courseType";
import {
  getclasstypeandtime,
  deleteclasstypeandtime,
} from "@/api/classtypeandtime";

export default {
  data() {
    return {
      props: { multiple: true, emitPath: false },
      options: [],
      tableData: [],
      tableHeight: 0,
      loading: false,
      coursePackageIds: [],
      idFlag: false,
      clockInDialogShow: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addClasstypeAndTimeDialog: {
        show: false,
        dialogRow: {},
        courseTypeList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      courseTypeData: [],
      format_course_type_list: {},
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatClassTypes();
    this.getClasstypeAndTime();
  },
  methods: {
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        console.log(res);
        this.courseTypeData = res.data.data.classTypeDataList;
        var courseTypeList = {
          courseTypeList: this.courseTypeData,
        };
        this.addClasstypeAndTimeDialog.courseTypeList = courseTypeList;
        this.format_course_type_list = res.data.data.formatClassTypeList;
      });
    },
    filterCourseType(value, item) {
      console.log(item.classtypeId);
      const type = parseInt(item.classtypeId);
      return (
        this.format_course_type_list[value] ==
        this.format_course_type_list[type]
      );
    },
    formatterCourseType(item) {
      const type = parseInt(item.classtypeId);
      return this.format_course_type_list[type];
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    getClasstypeAndTime() {
      const para = this.courseData;
      getclasstypeandtime(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.classtypeAndTimes;
      });
    },
    // 显示添加预约类型弹窗
    showClasstypeAndTimeDialog(val) {
      this.$store.commit("SET_CLASSTYPE_AND_TIME_DIALOG_TITLE", val);
      this.addClasstypeAndTimeDialog.show = true;
    },
    hideAddFundDialog() {
      this.addClasstypeAndTimeDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getClasstypeAndTime();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getClasstypeAndTime();
    },
    // 编辑操作方法
    onEditCoursePackage(row) {
      var param = Object.assign({}, row);
      this.addClasstypeAndTimeDialog.dialogRow = {
        param,
      };
      this.showClasstypeAndTimeDialog();
    },
    // 删除数据
    onDeleteCoursePackage(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteclasstypeandtime({ id: row.id }).then((res) => {
            console.log(res);
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getClasstypeAndTime();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


